import { isArray } from "lodash";
import { TOASTIFY_STATUS } from "../constants/application";
import { GENERIC_ERROR_MESSAGE } from "../constants/common";
import { AUTHENTICATION_TOKEN } from "../constants/storage";
import { getCookie } from "../helpers/browserStorage";
import { notifyToaster } from "../helpers/common";
import { store } from "../redux/Store";
import { patchJSON, postJSON } from "../utils/fetch";

const API_ENDPOINT = `${process.env.REACT_APP_API_HOST}/api/v4/onboarding_resources`;
const SKIP_ONBOARDING_API_ENDPOINT = `${process.env.REACT_APP_API_HOST}/api/v6/fleets`;
const CREATE_OR_UPDATE = "create_or_update";
const SMALL_FLEET_ONBOARDING = "small_fleet_onboarding";
const FLEET = "Fleet";

export const CreateOrUpdateSFOSteps = async ({ apiPayload }) => {
  try {
    const fleetId = store.getState().personalInfo.personalInfo.fleet_id;
    const response = await postJSON(
      `${API_ENDPOINT}/${CREATE_OR_UPDATE}`,
      {
        ...apiPayload,
        onboarding_type: SMALL_FLEET_ONBOARDING,
        onboarding_attachable_type: FLEET,
        onboarding_attachable_id: fleetId,
      },
      {
        Authorization: getCookie(AUTHENTICATION_TOKEN),
      }
    );

    if (response.error) {
      notifyToaster(response.error || GENERIC_ERROR_MESSAGE, {
        type: TOASTIFY_STATUS.error,
      });
      throw new Error(response.error);
    }

    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const skipOnboarding = async () => {
  try {
    const fleetId = store.getState().personalInfo.personalInfo.fleet_id;
    const response = await patchJSON(
      `${SKIP_ONBOARDING_API_ENDPOINT}/${fleetId}`,
      {
        fleet: {
          skip_onboarding: true,
        },
      },
      {
        Authorization: getCookie(AUTHENTICATION_TOKEN),
      }
    );

    if (response.error) {
      notifyToaster(
        isArray(response.error)
          ? response.error?.[0]
          : response.error || GENERIC_ERROR_MESSAGE,
        {
          type: TOASTIFY_STATUS.error,
        }
      );
      throw new Error(response.error);
    }

    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
